import { TranslateService } from "@ngx-translate/core";
import { TrainingTypeModel } from "../models/training/training-type.model";

export function getTrainingTypeLabel(
  type: TrainingTypeModel, 
  translateService: TranslateService
): string {
  switch (type) {
    case TrainingTypeModel.General:
      return translateService.instant('COMMON.FIELDS.TRAINING-TYPES.GENERAL');

    case TrainingTypeModel.IDD:
      return translateService.instant('COMMON.FIELDS.TRAINING-TYPES.IDD');

    case TrainingTypeModel.Compliance:
      return translateService.instant('COMMON.FIELDS.TRAINING-TYPES.COMPLIANCE');

    default:
      return 'n.a.';
  }
}